import { render, staticRenderFns } from "./StudyCourse.vue?vue&type=template&id=396168de&scoped=true"
import script from "./StudyCourse.vue?vue&type=script&lang=js"
export * from "./StudyCourse.vue?vue&type=script&lang=js"
import style0 from "./StudyCourse.vue?vue&type=style&index=0&id=396168de&prod&scoped=true&lang=css"
import style1 from "./StudyCourse.vue?vue&type=style&index=1&id=396168de&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "396168de",
  null
  
)

export default component.exports